import { useQueryClient, useMutation } from 'react-query';
import { shutdownAlisaTemplatesQuery } from '../../../../shared/api/queries';
import request from '../../../../../../helpers/request';
import {
  shutdownEmitter,
  shutdownEvtNames,
} from '../../../../shared/constants';

const { key: templatesQueryKey } = shutdownAlisaTemplatesQuery;

const deleteTemplate = async ({ templateId }) => {
  const res = await request.delete(
    `/Alert/alisa_templates/${templateId}`,
    {},
    'Не удалось удалить шаблон автоответа',
    'Error'
  );

  return res;
};

export const useDeleteResponseTemplate = () => {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation(deleteTemplate, {
    onSuccess: (res, { templateId }) => {
      if (res !== 'Error') {
        queryClient.setQueryData(templatesQueryKey, (oldData) =>
          oldData.filter((item) => item.id !== templateId)
        );
        shutdownEmitter.emit(shutdownEvtNames.autoResponseTemplateDelete, templateId);
      }
    },
  });

  return {
    deleteTemplate: deleteMutation.mutateAsync,
    loading: deleteMutation.isLoading,
  };
};
